import * as React from "react";
import styled, {
  css,
  ThemeContext
} from "styled-components";

import Grid from "src/library/components/Hedron";
import { InstalledModuleType } from "src/utils/constants";
import BrandedImage from "src/core/shared/components/BrandedImage";
import { IProduct } from "src/core/products/api/products.api";
import { IRole } from "src/core/shared/api/roles.api";
import { breakpoint } from "src/library/utils/styled-media-queries";

import { ProductDetails } from "../ProductDetails";
import { useQuickViewProduct } from "../QuickViewProduct";

export interface ICompactProductCardProps {
  productImage?: string;
  product: IProduct;
  ProductDetails?: React.ReactNode;
  className?: string;
  currentRole: IRole | null;
  installedModules: InstalledModuleType[];
  unavailable?: string | null;
  onCardActive?: (isActive: boolean) => void;
  originalProduct?: IProduct;
}

export const CompactProductCard: React.ReactFCWithChildren<ICompactProductCardProps> = ({
  product,
  productImage,
  className,
  unavailable,
  onCardActive,
  originalProduct
}) => {
  const theme = React.useContext(ThemeContext);
  const [ orderModalOpen, setOrderModalOpen ] = React.useState(false);
  const { setQuickViewProduct } = useQuickViewProduct();

  return (
    <ProductCardWrapper
      direction="horizontal"
      className={`${className} ${orderModalOpen ? "active" : ""}`}
    >
      <ProductImageWrapper>
        <div
          onClick={() => setQuickViewProduct(product.id)}
          className={productImage ? "hasImage" : "placeholder"}
        >
          <BrandedImage
            s3Key={productImage || theme.customDarkLogo}
            alt={product.description}
            level="public"
          />
        </div>
      </ProductImageWrapper>

      <ProductDetails
        onOrderModalChange={isOpen => {
          if (isOpen !== orderModalOpen && onCardActive) {
            onCardActive(isOpen);
          }

          setOrderModalOpen(isOpen);
        }}
        className="product-details"
        product={product}
        unavailable={unavailable}
        orderModalPosition="left"
        view="compact"
        originalProduct={originalProduct}
      />
    </ProductCardWrapper>
  );
};

export const ProductCardWrapper = styled(Grid.Bounds)`
${({ theme }) => css`
    padding-left: ${theme.spacing.padding.md};
    position: relative;
    background: ${theme.colors.white};
    display: flex;
    align-items: center;
    height: 100%;

    &.disabled {
      opacity: 0.3;
    }

    .product-card-actions {
      width: 100%;
    }

    .product-details {
      flex-wrap: wrap;

      ${breakpoint("sm", theme)} {
        flex-wrap: initial;
      }
    }
  `}
`;

export const ProductImageWrapper = styled(Grid.Bounds)`
  ${({ theme }) => css`
    width: 50px;
    height: 50px;
    display: none;

    ${breakpoint("sm", theme)} {
      display:flex;
      align-items: center;
    }

    a {
      background: ${theme.colors.white};
      box-sizing: border-box;
      
      &.hasImage {
        background: white;
      }
      position: relative;
      width: 100%;
      padding-bottom: 75%;
      overflow: hidden;

      .product-card-tags {
        z-index: 1;
        position: absolute;
        top: 0;
        left: ${theme.spacing.margins.sm};
      }


    img {
      min-height: 50px;
      min-width: 50px;
      top: 0;
      left: 0;
      max-width: 100%;
      max-height: 100%;
      position: absolute;
      &.placeholder {
        width: 30px;
      }
    }
  `}
`;
